import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class DebugItemValueActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/ItemValue/ItemValueBrowser")
	}

	render() {
		return (
			<Activity 
				name="DebugItemValue"
				RenderedComponent={this.RenderedComponent}
				context="DebugItemValue"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(DebugItemValueActivity)
